import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Checkbox as Checkbox$1, checkboxClasses, FormLabel, FormControlLabel } from '@mui/material';
import { styled } from '@mui/material/styles';
import { spacing, css, alpha, Stack, Box } from '@mui/system';
import { shouldNotForwardProps, withUtility, spacing as spacing$1 } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2;
const CheckboxStyled = styled(Checkbox$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  ${0}
`), spacing, withUtility(({
  palette
}, {
  error
}) => css(_t2 || (_t2 = _`
      color: ${0};
      padding: 0;
      margin-right: ${0};

      &.${0}.${0} {
        color: ${0};
      }

      &:not(.${0}).${0} {
        color: ${0};
        .PrivateSwitchBase-input {
          width: auto;
          height: auto;
          top: auto;
          left: auto;
          opacity: 1;
          visibility: hidden;

          &::before {
            content: '';
            position: absolute;
            width: calc(100% + 1px);
            height: calc(100% + 1px);
            left: -1px;
            top: -1px;
            background: ${0};
            visibility: visible;
          }
        }
      }

      &:not(.${0}):not(.${0}) {
        .PrivateSwitchBase-input {
          width: auto;
          height: auto;
          top: auto;
          left: auto;
          opacity: 1;
          visibility: hidden;

          &::before {
            content: '';
            position: absolute;
            width: calc(100% + 1px);
            height: calc(100% + 1px);
            left: -1px;
            top: -1px;
            background: ${0};
            visibility: visible;
          }
        }
      }
    `), palette(error ? 'error' : 'outline'), spacing$1(3), checkboxClasses.checked, checkboxClasses.disabled, error ? alpha(palette('error'), 0.5) : alpha(palette('onBackground'), 0.12), checkboxClasses.checked, checkboxClasses.disabled, error ? alpha(palette('error'), 0.38) : alpha(palette('onBackground'), 0.38), error ? alpha(palette('error'), 0.12) : alpha(palette('onBackground'), 0.12), checkboxClasses.checked, checkboxClasses.disabled, error ? palette('errorContainer') : palette('surfaceAt1'))));
const CheckboxGroup = _a => {
  var {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mr,
      mt,
      mx,
      my,
      children,
      id,
      label
    } = _a,
    props = __rest(_a, ["margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mr", "mt", "mx", "my", "children", "id", "label"]);
  return jsxs(Stack, Object.assign({
    display: "flex",
    flexDirection: "column",
    sx: {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    }
  }, {
    children: [label && jsx(FormLabel, Object.assign({
      sx: {
        marginBottom: 2
      },
      id: id
    }, {
      children: label
    })), jsx(Box, Object.assign({
      sx: {
        display: 'flex',
        flexDirection: 'column',
        ml: 3,
        gap: 4
      }
    }, props, {
      children: children
    }))]
  }));
};
const Checkbox = _a => {
  var {
      label,
      error
    } = _a,
    props = __rest(_a, ["label", "error"]);
  return jsx(FormControlLabel, {
    control: jsx(CheckboxStyled, Object.assign({
      label: label,
      error: error
    }, props)),
    label: label
  });
};

export { Checkbox, CheckboxGroup, CheckboxStyled };
